// ============================================
// 浏览器环境 process polyfill
// ============================================
// 原因：XEAOS 多个 Runtime（PromptRuntime/KnowledgeGraph/ToolRuntime 等）静态访问 process.cwd()
// Vite 默认只替换 process.env.NODE_ENV，不提供 process.cwd 等方法
// 这里在入口最早阶段注入 polyfill，让浏览器入口能正常加载
// Node 环境不受影响（process 已存在）
if (typeof process === 'undefined' || !process) {
  (window as any).process = {
    env: { NODE_ENV: 'development' },
    cwd: () => '/',
    platform: 'browser',
    versions: {},
    nextTick: (fn: Function) => setTimeout(fn, 0),
  };
} else if (typeof (process as any).cwd !== 'function') {
  // Vite 已替换 process.env 为 {}，但 cwd 不存在
  (process as any).cwd = () => '/';
  (process as any).platform = (process as any).platform || 'browser';
  (process as any).versions = (process as any).versions || {};
  (process as any).nextTick = (process as any).nextTick || ((fn: Function) => setTimeout(fn, 0));
}

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
